import { createSelector } from '@ngrx/store';

import { AppState } from 'store/root-reducer';

import { GenericError, ErrorType } from 'modules/shared/models/error.models';
import { RecordScreeningError, ScreeningErrors } from 'modules/shared/models/screening.models';
import * as error from 'store/actions/error.actions';
import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';

export interface State {
  screeningErrors: ScreeningErrors;
}

const initialState: State = {
  screeningErrors: {}
};

export function reducer(state: State = initialState, action: error.ErrorActions): State {
  switch (action.type) {
    case error.ErrorActionTypes.SET_SCREENING_ERROR: {
      const newState = Object.assign({}, state);
      let errorOfThisRecord = newState.screeningErrors[action.payload.recordId];
      if (errorOfThisRecord) {
        if (errorOfThisRecord.data.failedSearches.indexOf(action.payload.searchEngineType) < 0) {
          errorOfThisRecord.data.failedSearches.push(action.payload.searchEngineType);
        }
      } else {
        errorOfThisRecord = <GenericError<RecordScreeningError>> {
          type: ErrorType.SCREENING_ERROR,
          data: {
            recordId: action.payload.recordId,
            failedSearches: [action.payload.searchEngineType]
          }
        };
      }
      return {
        ...state,
        screeningErrors: {
          ...state.screeningErrors,
          [errorOfThisRecord.data.recordId]: errorOfThisRecord
        }
      };
    }
    case error.ErrorActionTypes.REMOVE_SCREENING_ERROR: {
      const newState = Object.assign({}, state);
      if (newState.screeningErrors) {
        const errorOfThisRecord = newState.screeningErrors[action.payload.recordId];
        if (errorOfThisRecord) {
          errorOfThisRecord.data.failedSearches = errorOfThisRecord.data.failedSearches
            .filter((searchEngine: SearchEngineTypeValue) => searchEngine !== action.payload.searchEngineType);
          if (errorOfThisRecord.data.failedSearches.length === 0) {
            delete newState.screeningErrors[action.payload.recordId];
          }
        }
      }

      return {
        ...state,
        screeningErrors: {
          ...newState.screeningErrors
        }
      };
    }
    default: {
      return state;
    }
  }
}

const errorSelector = (state: AppState) => state.error;
export const Selectors = {
  getScreeningErrors: createSelector(errorSelector, (state: State) => state.screeningErrors),
};
